import {createStyles} from '@material-ui/core';

const style = createStyles({
  spinner: {
    width: '32px',
    height: '32px',
  },
});

export default style;
